// 下载云盘返回的附件
export default {
    methods:{
        downloadResources(){
            // this.$nextTick(()=>{
            //     const dom = this.$el
            //     if (dom) {
            //         dom.addEventListener("click",()=>{
            //             if (this.instance) {
            //                 this.instance.get('//yp.mh.chaoxing.com/upload/yunpan/'+this.options.content+'/status').then(res => {
            //                     this.handleDownload(res)
            //                 })
            //             } else {
            //                 this.$axios.$get('//yp.mh.chaoxing.com/upload/yunpan/'+this.options.content+'/status').then(res => {
            //                     this.handleDownload(res)
            //                 })
            //             }
            //         })
            //     }
            // })
        },
        handleDownload(res){
            if(!res.download){
                return
            }
            let str1 = res.download.replace("http", "https");let yunpanDownloadBtn = document.getElementById("yunpanDownloadBtn")
            if(!yunpanDownloadBtn){
                yunpanDownloadBtn = document.createElement("a");
                yunpanDownloadBtn.setAttribute("id", "yunpanDownloadBtn");
                yunpanDownloadBtn.setAttribute("href", str1);
                yunpanDownloadBtn.setAttribute("download", str1);
                document.body.appendChild(yunpanDownloadBtn)
            }
            yunpanDownloadBtn.click()
        }
    }
}
